import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { accountResponseSchema } from '../schemas/account.schema';

const requestSchema = accountResponseSchema.partial().required({
  id: true,
});

/**
 * Update an existing account
 * @param account updated account object
 * @returns updated account info
 */
export function putAccountsAccountId(
  this: unknown,
  account: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).accountsUrl}/${account.id}`,
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(account),
      }
    )
  ).pipe(selectData(accountResponseSchema));
}
